import AssignmentIcon from "@mui/icons-material/Assignment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export const pipelinesAnalyticsMenu = [
  {
    section: "Stages",
    key: "pre-consultation",
    label: "Pre-Consultation",
    icon: <AssignmentIcon />,
  },
  {
    section: "Stages",
    key: "post-consultation",
    label: "Post-Consultation",
    icon: <CheckCircleIcon />,
  },
];
